'use strict';

window.APP_VERSION = APP_VERSION;
window.ENV = ENV;
window.SENTRY_DSN = SENTRY_DSN;
window.BASE_URL = BASE_URL;
window.APP_HOST = APP_HOST;

window.TOKEN_DOMAIN = TOKEN_DOMAIN;
window.SUPPORTED_LOCALES = SUPPORTED_LOCALES;
window.GIGYA_API_KEY = GIGYA_API_KEY;
window.GIGYA_API_HOST = GIGYA_API_HOST;
window.GIGYA_LOGIN_TOKEN_NAME = GIGYA_LOGIN_TOKEN_NAME;
window.IS_REMOTE_DEPLOYMENT = IS_REMOTE_DEPLOYMENT;

import 'core-js/stable';

// styles
import '../../style/bootstrap.less';

// init infrastructure
import '../typedef';

// init inner linking
import './linking';

// init LS message mechanism
import '../../shared/utils/LocalStorageEventManager';

// init everything related to views (regions-extras, injectify, helpers)
import 'injectify-include';
import '../../shared/helper/common';
import '../../shared/helper/localePathLogin';

// init sentry client (error tracking)
import '../sentry';

// init application
import {app} from './app';

app.start();



// WEBPACK FOOTER //
// ./js/login/bootstrap.js